import Button from '@cohort/merchants/components/buttons/Button';
import type {SelectOption} from '@cohort/merchants/components/form/select/SelectPicker';
import {SelectPicker} from '@cohort/merchants/components/form/select/SelectPicker';
import HighlightText from '@cohort/merchants/components/HighlightText';
import type {FacebookPage} from '@cohort/shared/apps/instagram/common';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

type FacebookPagePickerProps = {
  submitInProgress: boolean;
  pages: Array<FacebookPage>;
  onPageSelected: (page: FacebookPage) => void;
};
const FacebookPagePicker: React.FC<FacebookPagePickerProps> = ({
  pages,
  onPageSelected,
  submitInProgress,
}) => {
  const [selectedPage, setSelectedPage] = useState<SelectOption | undefined>(undefined);
  const {t} = useTranslation('app-facebook', {
    keyPrefix: 'facebookPagePicker',
  });

  const handleSubmit = (): void => {
    if (selectedPage === undefined) {
      return;
    }
    onPageSelected(selectedPage.value as FacebookPage);
  };

  if (pages.length === 0) {
    return <div>{t('noPagesLabel')}</div>;
  }

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="mt-1 flex w-full gap-x-3">
        <SelectPicker
          value={selectedPage}
          options={pages.map(
            page =>
              ({
                value: page,
                label: page.name,
              }) satisfies SelectOption
          )}
          onChange={selected => setSelectedPage(selected ?? undefined)}
          name="page"
          className="w-full"
        />
      </div>
      <div className="mt-2">
        <HighlightText type="info" text={<label>{t('pageSelectInfoMessage')}</label>} />
      </div>

      <div className="mt-4">
        <Button
          className="self-end"
          onClick={handleSubmit}
          disabled={selectedPage === undefined || submitInProgress}
        >
          {t('connectPageButton')}
        </Button>
      </div>
    </div>
  );
};

export default FacebookPagePicker;
